// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"b1f607cc","453":"b52b8293"}[chunkId] + ".chunk.css";
};